app = angular.module("seismology")

app.controller "NotificationPanelCtrl", ($scope, $window, $mdPanel, Notification, Users, Books) ->
  $scope.notifications = Notification.getList(50)
  $scope.notifications.$loaded ->
    for n in $scope.notifications
      n.new = !n.read
      n.read = true
      $scope.notifications.$save(n)
  $scope.Books = Books
  $scope.Users = Users
  $scope.moment = $window.moment
  $scope.jumpToSource = (rec) ->
    $scope.notifications.jumpToSource(rec)
    $window.panel.hide()


app.controller "HeaderCtrl", ($scope, $state, $firebaseAuth, $mdDialog, $mdPanel, $window, $translate, CurrentUser, Notification, DesktopNotification) ->
  $scope.currentUser = CurrentUser.get()
  console.log $scope.currentUser
  $scope.logout = ->
    console.log "sign out"
    $firebaseAuth().$signOut()
    $state.go('signin')
  $scope.toggleDesktopNotification = ->
    DesktopNotification.enableNotification()
  $scope.notifications = Notification.getList()

  
  $scope.showNotifications = ->
    template = 'templates/partial/panel-notification.html'
    template = 'templates/partial/panel-notification-en.html' if $translate.use() is "en"
    
    position = $mdPanel.newPanelPosition()
      .relativeTo('.notification-btn')
      .addPanelPosition($mdPanel.xPosition.ALIGN_END, $mdPanel.yPosition.BELOW)
    config =
      attachTo: angular.element(document.body)
      controller: 'NotificationPanelCtrl'
      templateUrl: template
      panelClass: 'notification-panel'
      position: position
      clickOutsideToClose: true
      escapeToClose: true
      focusOnOpen: false
      zIndex: 9999999
    $mdPanel.open(config).then (panel) ->
      $window.panel = panel

  $scope.editProfile = ->
    $mdDialog.show
      controller: ($scope, $mdDialog, CurrentUser) ->
        $scope.currentUser = CurrentUser.get()
        $scope.cancel = -> $mdDialog.cancel()
        $scope.save = (ev)->
          console.log $scope.currentUser.profile
          $scope.currentUser.$save().then ->
            alert = $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('確認')
            .textContent('プロフィールを編集しました')
            .ariaLabel('Edited profile')
            .ok('閉じる')
            .targetEvent(ev)
            $mdDialog.show(alert)
      templateUrl: 'templates/dialogs/edit-profile.html'
      parent: angular.element(document.body)
      clickOutsideToClose: false


app.controller 'UserStatusCtrl', ($scope, CurrentUser, LevelTable) ->
  $scope.currentUser = CurrentUser.get()
  $scope.currentUser.$loaded ->
    $scope.levelPoints =
      LevelTable.getLevelPoints($scope.currentUser.currentLevel || 1)
    $scope.pointsInCurrentLevel =
      LevelTable.pointsInCurrentLevel($scope.currentUser.points)
    $scope.levelProgress =
      ($scope.pointsInCurrentLevel/$scope.levelPoints)*100



// WEBPACK FOOTER //
// ./app/controllers/partial_controllers.coffee